import { memo } from 'react';
import { CircularProgress, Container } from '@mui/material';

function BodyLoader() {
  return (
    <Container
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
      }}
    >
      <CircularProgress size={50} />
    </Container>
  );
}

export default memo(BodyLoader);
